
class MatterPortHeader extends HTMLElement {

    /**
     * Create a new matterport-header Element
     */
    constructor() {
        super();

        // Parse Points
        try {
            this.points = JSON.parse(document.querySelector('main').dataset.points);
        } catch {
            this.points = {};
        }

        // Build Sweep Map
        let pointsAsMap = new Map;
        for (const [id, category] of Object.entries(this.points)) {
            for (const sweep of category.children) {
                pointsAsMap.set(sweep.sweep, sweep);
            }
        }
        this.pointsMap = pointsAsMap;

        // Description
        let description = this.querySelector('.description');
        if (description) {
            this.description = description;

            let infoButton = document.createElement('BUTTON');
            infoButton.type = 'button';
            infoButton.classList.add('info-button');
            infoButton.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                </svg>
            `;
            infoButton.addEventListener('click', this.toggleDescription.bind(this, 'toggle'));
            this.querySelector('h1').appendChild(infoButton);

            let closeButton = document.createElement('BUTTON');
            closeButton.type = 'button';
            closeButton.classList.add('close-button');
            closeButton.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                </svg>
            `;
            closeButton.addEventListener('click', this.toggleDescription.bind(this, 'close'));
            this.appendChild(closeButton);
        }

        // Subtitle
        this.subtitle = document.createElement('h2');
        this.subtitle.hidden = true;

        if (this.description) {
            this.insertBefore(this.subtitle, this.description);
        } else {
            this.appendChild(this.subtitle);
        }

        // Add Listener
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.trackSweep.bind(this))
        } else {
            setTimeout(() => {
                this.trackSweep();
            }, 100);
        }
    }

    /**
     * Track Sweep
     */
    async trackSweep() {
        const sdk = await window.mpSdk;
        const self = this;

        sdk.Sweep.current.subscribe({
            onChanged(sweep) {
                if (self.pointsMap.has(sweep.id)) {
                    self.subtitle.innerText = self.pointsMap.get(sweep.id).title;
                    self.subtitle.hidden = false;
                } else {
                    self.subtitle.innerText = '';
                    self.subtitle.hidden = true;
                }
            }
        });
    }

    static wait(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    /**
     * Toggle Description
     */
    async toggleDescription(state) {
        if (!this.classList.contains('active') && (state === 'toggle' || state === 'open')) {
            this.description.hidden = false;
            await this.constructor.wait(25);
            this.classList.add('active');
        } else if (this.classList.contains('active') && (state === 'toggle' || state === 'close')) {
            this.description.hidden = true;
            await this.constructor.wait(25);
            this.classList.remove('active');
        }
    }

}

window.customElements.define('matterport-header', MatterPortHeader);
